import React, {useState} from "react";
import {useReadAccountContactList} from "../hooks";
import {BasicSearchType} from "../../../../../types/common/basic";
import {initSearchState} from "../../../../../state/search";
import {SubmitHandler, useForm} from "react-hook-form";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

type Props = {
    id: string;
};

/**
 * 연락처 탭
 * @param props
 * @returns
 */
export const ContactTab = ({id}: Props) => {
    const {goToNavigation} = useGoToNavigation();

    const [searchOption, setSearchOption] =
        useState<BasicSearchType>(initSearchState);
    const {data} = useReadAccountContactList({
        searchData: {
            accountId: id,
            ...searchOption,
        },
    });

    const {register, handleSubmit, reset} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<BasicSearchType> = (submitData) => {
        setSearchOption(submitData);
    };

    const clickPagination = (i: number) => {
        setSearchOption({...searchOption, pageNo: i});
    };

    return (
        <>
            <form className="content_wrap" onSubmit={handleSubmit(onSubmit)}>
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label className="form-label frm_label">검색어</label>
                            <select
                                className="form-select w-150px"
                                {...register("keywordType")}
                            >
                                <option value="0">전체</option>
                                <option value="1">이름</option>
                                <option value="2">근무처전화</option>
                                <option value="3">휴대폰</option>
                            </select>
                            <input
                                type="text"
                                className="form-control w-250px me-0"
                                {...register("keyword")}
                            />
                            <button className="btn btn-info btn_search">
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                    }
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6"></div>
                </div>
            </form>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        연락처 목록(<span>{data?.totalCount ?? 0}</span>건)
                    </h6>
                    <div className="table_toolbar"></div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            {/*<th>*/}
                            {/*    <div className="checkbox_outer">*/}
                            {/*        <input className="form-check-input" type="checkbox"/>*/}
                            {/*    </div>*/}
                            {/*</th>*/}
                            <th>이름</th>
                            <th>직함</th>
                            <th>부서</th>
                            <th>팀</th>
                            <th>산업구분</th>
                            <th>근무처 전화</th>
                            <th>휴대폰</th>
                            <th>회사 이메일</th>
                            <th>상태</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data?.SearchAccountAddressRes.length === 0 ? (
                            <EmptyTableRow colSpan={9}/>
                        ) : (
                            data?.SearchAccountAddressRes.map((item, index) => (
                                <tr className="cursor_pointer" key={index} onClick={() => {
                                    goToNavigation(
                                        "customer/contact/detail/" + item?.contactid,
                                        {...item, contactId: item.contactid},
                                        false
                                    );
                                }}>
                                    {/*<td>*/}
                                    {/*    <div className="checkbox_outer">*/}
                                    {/*        <input className="form-check-input" type="checkbox"/>*/}
                                    {/*    </div>*/}
                                    {/*</td>*/}
                                    <td className="text-center">{item?.fullName ?? "-"}</td>
                                    <td className="text-center">{item?.jobTitle ?? "-"}</td>
                                    <td className="text-center">{item?.department ?? "-"}</td>
                                    <td className="text-center">{item?.newTxtTeam ?? "-"}</td>
                                    <td className="text-center">
                                        {item?.industryName ?? "-"}
                                    </td>
                                    <td className="text-center">{item?.telephone1 ?? "-"}</td>
                                    <td className="text-center">{item?.mobilePhone ?? "-"}</td>
                                    <td className="text-center">
                                        {item?.emailAddress1 ?? "-"}
                                    </td>
                                    <td className="text-center">{item?.stateCode ?? "-"}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationSub
                    totalCount={data?.totalCount ?? 0}
                    currentPage={searchOption.pageNo}
                    onChangeCallback={(i: number) => clickPagination(i)}
                />
            </div>
        </>
    );
};
